import { Component, Input } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { Notification } from '@base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-push-message-history-item',
    templateUrl: './push-message-history-item.component.html',
    styleUrls: ['./push-message-history-item.component.scss']
})
export class PushMessageHistoryItemComponent extends BaseComponent<BaseState> {
    @Input() Entity: Notification;

    constructor(A: ServiceBagService) {
        super(A, 'PushMessageHistoryItemComponent', BaseState);
    }
}
